<template>
  <div class="tile">
    <div class="icon-space">
      <img
        class="h-100"
        :src="require('@/assets/images/logotyp_dark.png')"
        alt="logo"
      />
    </div>
    <transition name="fade" mode="out-in" tag="div">
        <login-form v-if="!showChangePassword" @forgot-password="forgotPasswordChange"/>
        <change-password-form @forgot-password="forgotPasswordChange" v-else />
    </transition>
  </div>
</template>

<script>
import { ref } from 'vue';

import LoginForm from '../components/login/LoginForm.vue';
import ChangePasswordForm from '../components/login/ChangePasswordForm.vue';

export default {
  name: 'login',

  components: { ChangePasswordForm, LoginForm },

  setup() {
    const showChangePassword = ref(false);

    function forgotPasswordChange() {
      showChangePassword.value = !showChangePassword.value;
    }

    return {
      forgotPasswordChange,
      showChangePassword,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/css/colors.scss';

.tile {
  align-items: center;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  height: 500px;
  justify-content: center;
  width: 400px;
  box-shadow:
    -10px 0px 13px -7px #000000,
    10px 0px 13px -7px #000000,
    5px 5px 15px 5px rgba(0,0,0,0);

  .icon-space {
    align-items: center;
    border-radius: 90px;
    display: flex;
    height: 150px;
    justify-content: center;
    width: 80px;
  }

  .content {
    height: 265px;
  }
}

.fade-leave-active,
.fade-enter-active {
  transition: opacity .5s ease-in;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

</style>
